import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// web-app-chrome-card imports
import { IContainer, IProps, IState } from "./WebAppChromeCard.d";
import { webAppChromeCardFragments } from "./WebAppChromeCard.gql";

// components
import { GradientCard } from "@clockwise/web-commons/src/components/gradient-card";

// state
import { IReduxState } from "@reducers/root.reducer";
import { webAppHomeDismissedExtensionPromotion } from "@state/local-storage";

// util
import { track, TrackingEvents } from "@util/analytics.util";
import { UserFlags, validateFlagsErrorable, isFlagSet } from "@util/flags.util";

// constants
import { browserName, extensionURLForBrowser } from "@clockwise/web-commons/src/util/browser.util";

///////////////
// Component //
///////////////
class WebAppChromeCardCmpt extends React.Component<IProps, IState> {
  private onDismissPromotion = () => {
    track(TrackingEvents.APP_HOME.CHROME_EXTENSION_INSTALL_DIMISS);
    webAppHomeDismissedExtensionPromotion.set(true);
  };

  public render() {
    const flagsErrorable =
      this.props.viewer &&
      this.props.viewer.user &&
      this.props.viewer.user.chromeExtensionFlagsErrorable;

    const hasInstalledChromeExtension =
      validateFlagsErrorable(flagsErrorable) &&
      isFlagSet(UserFlags.Onboarding.HasInstalledChromeExtension.name, flagsErrorable);

    const isDismissed = hasInstalledChromeExtension || webAppHomeDismissedExtensionPromotion.get();

    if (!extensionURLForBrowser) {
      return <></>;
    }

    return (
      <GradientCard
        label="Clockwise works best next to Google Calendar."
        buttonLabel={`Add to ${browserName}`}
        isDismissed={isDismissed}
        onClick={() => track(TrackingEvents.APP_HOME.CHROME_EXTENSION_INSTALL)}
        onDismiss={this.onDismissPromotion}
        href={`${extensionURLForBrowser}?utm_medium=referral&utm_source=product&utm_campaign=web-callout`}
        cardStyle={this.props.cardStyle}
      />
    );
  }
}

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const WebAppChromeCardRedux = connect(mapStateToProps, {})(WebAppChromeCardCmpt);

///////////
// Relay //
///////////

export const WebAppChromeCard = createFragmentContainer(
  WebAppChromeCardRedux,
  webAppChromeCardFragments,
);
